import http from 'hub-http/clients/apiClient';
const FORMS_SETTINGS_BASE_URL = 'forms-portal-settings/v1/setting';
export const fetchFormSettings = key => http.get(`${FORMS_SETTINGS_BASE_URL}?name=${key}`);
export const fetchFormStyleSettings = () => fetchFormSettings('forms_style');